$.ready(function() {
	//{build indicators
	//holder
	var indicators = game.indicators_display = $.div().after(game.frame);
	
	//left and right strips
	indicators.left   = $.div().addClass('left side-indicator').appendTo(indicators);
	indicators.right  = $.div().addClass('right side-indicator').appendTo(indicators);
	
	//line number order
	indicators.left_nums = [ 4, 20, 2, 9, 26, 16, 7, 1, 6, 17, 27, 8, 3, 21, 5 ];
	indicators.right_nums  = [ 12, 23, 18, 14, 29, 24, 11, 30, 10, 25, 28, 15, 19, 22, 13 ];
	
	//save for later
	var lpos = [ 4, 20, 2, 9, 26, 16, 7, 1, 6, 17, 27, 8, 3, 21, 5 ];
	var rpos = [ 12, 23, 18, 14, 29, 24, 11, 30, 10, 25, 28, 15, 19, 22, 13 ];
	
	//holds the sections of the divs (top, mid, bottom)
	indicators.right.spots = [];
	indicators.left.spots = [];
	
	//holds each indicator
	indicators.indications = [];
	
	//initialize array to correct size
	for (var num_lines = 0; num_lines < 30; num_lines++) {
		indicators.indications.push('');
	}
	
	//for symbols in top line
	indicators.left.spots.push($.div().addClass('top').appendTo(indicators.left));
	indicators.right.spots.push($.div().addClass('top').appendTo(indicators.right));
	
	//for symbols in mid line
	indicators.left.spots.push($.div().addClass('mid').appendTo(indicators.left));
	indicators.right.spots.push($.div().addClass('mid').appendTo(indicators.right));
	
	//for symbols in bottom line
	indicators.left.spots.push($.div().addClass('bottom').appendTo(indicators.left));
	indicators.right.spots.push($.div().addClass('bottom').appendTo(indicators.right));
	
	//3 sections and 5 indicators per section
	for (var spots = 0; spots < 3; spots++) {
		for (var ind = 0; ind < 5; ind++) {
			//each indicator is shown on the dom in the lin number order (left_nums/right_nums)
			//but is stored in numerical order for easy access in indicators.indications
			
			var r_ind = indicators.right_nums.shift();
			var l_ind = indicators.left_nums.shift();
			
			indicators.indications[l_ind - 1] = $.div().addClass(l_ind + ' tag').appendTo(indicators.left.spots[spots]);
			indicators.indications[r_ind - 1] = $.div().addClass(r_ind + ' tag').appendTo(indicators.right.spots[spots]);
			$.div().html(l_ind).appendTo(indicators.indications[l_ind - 1]);
			$.div().html(r_ind).appendTo(indicators.indications[r_ind - 1]);
		}
	}
	//}
	
	//store line being animated
	var current_line = 0;
	
	game.pays.on('update', function(e) {
		var config = e.detail;
		
		//remvove prev line
		indicators.indications[current_line].removeClass('win');
		
		//new line
		current_line = config.line - 1;
		
		//which line is being isplayed
		indicators.attr('class', config.line);
		
		//animate
		indicators.indications[current_line].addClass('win');
		
		//remove animation
		setTimeout(function() {
			indicators.indications[current_line].removeClass('win');
		}, 2000);
	});
	
	game.on('round_start', function() {
		//remove animation on spin
		indicators.indications[current_line].removeClass('win');
	});
	
	game.pays.on('line', function(e) {
		if (lpos.indexOf(e.detail.lineNumber + 1) > -1) {
			if (e.detail.reel === 0) {
				e.detail.track = indicators.indications[e.detail.lineNumber];
			}
			
			if (e.detail.reel === e.detail.line.length - 1) {
				e.detail.offset *= 3;
			}
		}
		
		if (rpos.indexOf(e.detail.lineNumber + 1) > -1) {
			if (e.detail.reel === e.detail.line.length - 1) {
				e.detail.track = indicators.indications[e.detail.lineNumber];
			}
			
			if (e.detail.reel === 0) {
				e.detail.offset *= 3;
			}
		}
	});
});



/** WEBPACK FOOTER **
 ** ./public-src/js/indicators.js
 **/